export const KPI_ACCENTS = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
    'linear-gradient(135deg, #f6c23e 0%, #fd7e14 100%)',
    'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
];

export const PATIENT_INFORMATION_STATS = [
    { key: 'TOTAL_PATIENTS', label: 'Total Patients', icon: 'bi-people-fill' },
    { key: 'ACTIVE_PATIENTS', label: 'Active Patients', icon: 'bi-person-check' },
    { key: 'INACTIVE_PATIENTS', label: 'Inactive Patients', icon: 'bi-person-dash' },
    { key: 'NEW_PATIENTS_LAST_30_DAYS', label: 'New Patients (30 days)', icon: 'bi-person-plus' },
    { key: 'PATIENTS_WITH_EMAIL', label: 'With Email', icon: 'bi-envelope' },
    { key: 'PATIENTS_WITH_SMS', label: 'With SMS', icon: 'bi-phone' },
    { key: 'PATIENTS_WITH_PHONE', label: 'With Phone', icon: 'bi-telephone' },
    { key: 'OPTED_FOR_EMAIL', label: 'Opted for Email', icon: 'bi-envelope-check' },
    { key: 'OPTED_FOR_SMS', label: 'Opted for SMS', icon: 'bi-chat-dots' },
];

// Patient status, age group, and communication breakdowns — mirrors the admin Patient Stats charts.
export const PATIENT_STATUS_STATS = [
    { key: 'ACTIVE_PATIENTS', label: 'Active', color: '#22c55e' },
    { key: 'INACTIVE_PATIENTS', label: 'Inactive', color: '#64748b' },
];

export const PATIENT_AGE_GROUP_STATS = [
    { key: 'PATIENTS_CHILDREN', label: 'Children (0-12)', color: '#6366f1' },
    { key: 'PATIENTS_TEENAGER', label: 'Teenager (13-18)', color: '#06b6d4' },
    { key: 'PATIENTS_ADULT', label: 'Adult (19-64)', color: '#22c55e' },
    { key: 'PATIENTS_SENIOR', label: 'Senior (65+)', color: '#f97316' },
    { key: 'PATIENTS_AGE_UNKNOWN', label: 'Unknown', color: '#94a3b8' },
];

export const PATIENT_COMMUNICATION_STATS = [
    { key: 'PATIENTS_WITH_EMAIL', label: 'Email', color: '#6366f1' },
    { key: 'PATIENTS_WITH_SMS', label: 'Cell Phone', color: '#10b981' },
    { key: 'PATIENTS_WITH_PHONE', label: 'Home Phone', color: '#f59e0b' },
];

export const RETURN_ON_INVESTMENT_STATS = [
    {
        key: 'CONFIRMED_APPOINTMENTS_LAST_30_DAYS',
        label: 'Confirmed Appointments',
        icon: 'bi-calendar-check',
        dollarValue: 15,
    },
    {
        key: 'REPUTATION_FEEDBACK_RECEIVED',
        label: 'Reputation Feedback',
        icon: 'bi-emoji-smile',
        dollarValue: 10,
    },
    {
        key: 'REPUTATION_COMMENTS_RECEIVED',
        label: 'Comments Received',
        icon: 'bi-chat-left-text',
        dollarValue: 20,
    },
];

export const EMAIL_STATS_WINDOWS = [
    { days: 30, label: '30 days' },
    { days: 60, label: '60 days' },
    { days: 90, label: '90 days' },
];

export const EMAIL_STATS_METRICS = [
    { id: 'sent', label: 'Sent' },
    { id: 'opened', label: 'Opened' },
];

export const emailStatKey = (keyPrefix, metric, days) =>
    metric === 'opened' ? `${keyPrefix}_OPENED_${days}_DAYS` : `${keyPrefix}_${days}_DAYS`;

export const EMAIL_STATS_CATEGORIES = [
    { keyPrefix: 'EMAIL_APPOINTMENT_REMINDER', label: 'Appointment Reminders' },
    { keyPrefix: 'EMAIL_ARTICLE', label: 'Articles' },
    { keyPrefix: 'EMAIL_GL_PICKUP', label: 'Glass Pickups' },
    { keyPrefix: 'EMAIL_CL_PICKUP', label: 'Contact Lens Pickups' },
    { keyPrefix: 'EMAIL_RECALL_REMINDER', label: 'Recall Reminders' },
    { keyPrefix: 'EMAIL_SURVEY_INVITE', label: 'Survey Invites' },
    { keyPrefix: 'EMAIL_THANK_YOU', label: 'Thank You Emails' },
    { keyPrefix: 'EMAIL_BIRTHDAY', label: 'Birthday Emails' },
    { keyPrefix: 'EMAIL_WELCOME', label: 'Welcome' },
    { keyPrefix: 'EMAIL_RESCHEDULE_FOLLOW_UPS', label: 'Reschedule Follow-ups' },
    { keyPrefix: 'EMAIL_EDGE_REMINDER', label: 'Edge Reminders' },
    { keyPrefix: 'EMAIL_CL_REPLACE_REORDER', label: 'CL Replace / Reorder' },
    { keyPrefix: 'EMAIL_PATIENT_CONSENT', label: 'Patient Consent' },
    { keyPrefix: 'EMAIL_BLAST', label: 'Email Blast' },
    { keyPrefix: 'EMAIL_NEWSLETTER', label: 'Newsletter' },
    { keyPrefix: 'EMAIL_OTHER', label: 'Other' },
];

export const SYSTEM_EMAIL_STATS_CATEGORIES = [
    { keyPrefix: 'EMAIL_SYSTEM_SUMMARY', label: 'Daily Summaries' },
    { keyPrefix: 'EMAIL_SYSTEM_INVALID_DETAILS', label: 'Invalid Details' },
    { keyPrefix: 'EMAIL_SYSTEM_CONFIRMATION', label: 'Confirmations' },
    { keyPrefix: 'EMAIL_SYSTEM_BOOKING_REQUEST', label: 'Booking Requests' },
    { keyPrefix: 'EMAIL_SYSTEM_CL_ORDER_REQUEST', label: 'CL Order Requests' },
    { keyPrefix: 'EMAIL_SYSTEM_REPUTATION_COMMENT', label: 'Reputation Comments' },
    { keyPrefix: 'EMAIL_SYSTEM_RECALL_REPORT', label: 'Recall Reports' },
    { keyPrefix: 'EMAIL_SYSTEM_CLINIC_NOTICE', label: 'Clinic Notices' },
];

export const SMS_STATS_CATEGORIES = [
    { keyPrefix: 'SMS_APPOINTMENT_REMINDER', label: 'Appointment Reminders' },
    { keyPrefix: 'SMS_BIRTHDAY', label: 'Birthday' },
    { keyPrefix: 'SMS_PICKUP', label: 'Pickups' },
    { keyPrefix: 'SMS_RECALL_REMINDER', label: 'Recall Reminders' },
    { keyPrefix: 'SMS_THANK_YOU', label: 'Thank You' },
    { keyPrefix: 'SMS_BLAST', label: 'SMS Blast' },
    { keyPrefix: 'SMS_NEWSLETTER', label: 'Newsletter' },
];

export const CAMPAIGN_INFORMATION_STATS = [
    { keyPrefix: 'EMAIL_BLAST', label: 'Email Blast', icon: 'bi-envelope-fill' },
    { keyPrefix: 'EMAIL_NEWSLETTER', label: 'Email Newsletter', icon: 'bi-newspaper' },
    { keyPrefix: 'SMS_BLAST', label: 'SMS Blast', icon: 'bi-chat-dots-fill' },
    { keyPrefix: 'SMS_NEWSLETTER', label: 'SMS Newsletter', icon: 'bi-phone' },
];

export const CAMPAIGN_CHANNEL_STATS = [
    { id: 'email', label: 'Email', color: '#6366f1', keyPrefixes: ['EMAIL_BLAST', 'EMAIL_NEWSLETTER'] },
    { id: 'sms', label: 'SMS', color: '#10b981', keyPrefixes: ['SMS_BLAST', 'SMS_NEWSLETTER'] },
];

export const buildStatsMap = (stats = []) =>
    stats.reduce((acc, stat) => {
        if (stat?.statsName) {
            acc[stat.statsName] = stat.statsValue ?? '0';
        }
        return acc;
    }, {});

export const getLatestStatTimestamp = (stats = []) => {
    if (!stats.length) {
        return null;
    }

    const timestamps = stats
        .map((stat) => stat.modifiedAt || stat.createdAt)
        .filter(Boolean)
        .sort()
        .reverse();

    return timestamps[0] || null;
};
